import { ObservationDuration } from "store/dashboard/observations/types";

export const ObservationDurationConstants = {
  PER_DAY: { LABEL: "Per Day", VALUE: ObservationDuration.PER_DAY },
  PER_WEEK: { LABEL: "Per Week", VALUE: ObservationDuration.PER_WEEK },
  PER_MONTH: { LABEL: "Per Month", VALUE: ObservationDuration.PER_MONTH },
  PER_YEAR: { LABEL: "Per Year", VALUE: ObservationDuration.PER_YEAR },
};
